const SCOPE = 'bpcs';

export default SCOPE;
